// FOS-CARD-DESCRIPTIONS-001 — read side of catalog descriptions.
// The RLS policy on fragrance.catalog_description only exposes status='live'
// to anon/authenticated; the client filter is belt-and-braces so a policy
// change can never surface review copy through this path.

/**
 * @returns {Promise<string|null>} the live description text, or null when
 * there is none (or no catalogId). Throws on a transport/query error.
 */
export async function fetchLiveCatalogDescription(supabase, catalogId) {
  if (!catalogId) return null
  const { data, error } = await supabase
    .schema('fragrance')
    .from('catalog_description')
    .select('description')
    .eq('catalog_id', catalogId)
    .eq('status', 'live')
    .maybeSingle()
  if (error) throw error // the Supabase error object itself; the hook stores it as-is
  const text = typeof data?.description === 'string' ? data.description.trim() : ''
  return text || null
}

/**
 * The maintained community rating on the catalog row, the only basis the scent
 * guide will describe. Returns null when there is no catalogId or no rating.
 * Throws on a transport/query error.
 */
export async function fetchCatalogCommunityRating(supabase, catalogId) {
  if (!catalogId) return null
  const { data, error } = await supabase
    .schema('fragrance')
    .from('catalog')
    .select('fragrantica_rating')
    .eq('id', catalogId)
    .maybeSingle()
  if (error) throw error
  const value = data?.fragrantica_rating
  return value === null || value === undefined || value === '' ? null : Number(value)
}
